import { ArticleModel } from './article.model';
import { PackService } from '../services/pack.service';
import { Estate } from '../utils/enum.util';
import { ValidatorService, EvalidatorRequire } from '../services/validator.service';

export class PackModel {

    private _name: string             = '';
    private _articles: ArticleModel[] = [];
    private _id: string;
    private _state: Estate            = Estate.Save;
    private _errors: any;

    //*************************************
    //************ CONSTRUCTOR ************
    //*************************************
    constructor(public packService: PackService) {

    };

    //*************************************
    //*************** ACTION **************
    //*************************************
    public save() {
        if (this.validate() && this.validateArticles()) {
            this.state = Estate.Saving;
            if (this.id == undefined) {
                this.packService.create(this);
            } else {
                this.packService.update(this);
            }
            return true;
        } else {
            this.state = Estate.Error;
            return false;
        }
    }

    public modelChange() {
        this.save();
    }

    public delete() {
        this.packService.delete(this);
    }

    //*************************************
    //************* VALIDATOR *************
    //*************************************
    public validate(): boolean {

        let validator = new ValidatorService();
        validator
            .addField(this._name, 'name', EvalidatorRequire.Require, [
                {fn: validator.stringLength, options: {min: 2, max: 42}}
            ]);
        this._errors = validator.run();
        return (this._errors == null);
    }

    public validateArticles(): boolean {
        let isValide = true;
        this.articles.forEach((article: ArticleModel)=> {
            if (!article.validate())
                isValide = false;
        });
        return isValide;
    }

    //*************************************
    //************** METHOD ***************
    //*************************************
    addArticle() {
        this.articles.push(new ArticleModel(this));
    }

    clone(): PackModel {
        let clone    = new PackModel(this.packService);
        clone.name   = this.name;
        clone.id     = this.id;
        clone.state  = this.state;
        let articles = [];
        this.articles.forEach((a)=> {
            let article      = new ArticleModel(clone);
            article.about    = a.about;
            article.bike     = a.bike;
            article.free     = a.free;
            article.type     = a.type;
            article.price    = a.price;
            article.quantity = a.quantity;
            article.errors   = a.errors;
            articles.push(article);
        });
        clone.articles = articles;
        return clone;
    }

    //*************************************
    //********** GETTER / SETTER **********
    //*************************************
    get name(): string {
        return this._name;
    }

    set name(value: string) {
        this._name = value;
    }

    get articles(): ArticleModel[] {
        return this._articles;
    }

    set articles(value: ArticleModel[]) {
        this._articles = value;
    }

    get id(): string {
        return this._id;
    }

    set id(value: string) {
        this._id = value;
    }

    get state(): Estate {
        return this._state;
    }

    set state(value: Estate) {
        this._state = value;
    }

    get errors(): any {
        return this._errors;
    }

    set errors(value: any) {
        this._errors = value;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/home/models/pack.model.ts